import React from 'react'
import { WeightLossRoot, WeightLossContainer, ButtonWrapper } from './WeightLoss.styles'
import { CopyColumnHeader } from '../../RawBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import smallDog from '../../../../../public/assets/raw-benefits/small-dog-standing-for-we-feed-raw-bowl.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { Button } from 'components/Button'

export const WeightLoss: React.FC = () => {
  const { t } = useTranslation()

  const WeightLossCopy = () => (
    <Stack gap="3" direction="column">
      <CopyColumnHeader>
        {t('raw-benefits:weight-loss.title')}
      </CopyColumnHeader>
      <Text>{t('raw-benefits:weight-loss.body.0')}</Text>
      <Text>{t('raw-benefits:weight-loss.body.1')}</Text>
      <Text>{t('raw-benefits:weight-loss.body.2')}</Text>
    </Stack>
  )

  return (
    <WeightLossRoot>
      <WeightLossContainer>
        <ImageWithText
          copyColumn={<WeightLossCopy />}
          imageSrc={smallDog}
          imageAlt="raw-benefits:weight-loss.image-alt"
          imageSide="left"
          isMobileImageBottom
        />
        <ButtonWrapper>
          <Link href="/meal-plan" passHref>
            <Button as="a" className="cta">
              {t('raw-benefits:hero.primary-cta')}
            </Button>
          </Link>
        </ButtonWrapper>
      </WeightLossContainer>
    </WeightLossRoot>
  )
}

WeightLoss.displayName = 'WeightLoss'
